/**
 * Created by Sergii on 03.10.2018.
 */
import { connect } from 'react-redux';
import * as newUserActions from '../actions/NewUserActions.js';
import {NewUserWnd} from '../components/NewUserWnd.jsx';

const mapStateToProps = state => {
    return {
        show: state.newUser.show,
        error: state.newUser.error,
        username: state.newUser.username,
        email: state.newUser.email,
        password: state.newUser.password,
        retypedPassword: state.newUser.retypedPassword,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        onHide: () => {
            dispatch(newUserActions.showNewUserWnd(false));
            dispatch(newUserActions.clearNewUserData());
        },
        onSave: () => {dispatch(newUserActions.addNewUser())},
        onUserDataChanged: (field, value) => {dispatch(newUserActions.updateNewUserData(field, value))}
    }
};

const NewUserWndController = connect(
    mapStateToProps,
    mapDispatchToProps
)(NewUserWnd);

export default NewUserWndController;
